import { useSchedulingAppointmentTypes } from 'app/components/scheduling-appointment-types/useSchedulingAppointmentTypes'
import { SchedulingAppointmentTypesComponent } from 'app/components/scheduling-appointment-types/SchedulingAppointmentTypesComponent'

export default function AppointmentTypes() {
  const hookData = useSchedulingAppointmentTypes()
  return <SchedulingAppointmentTypesComponent {...hookData} />
}
